import { CREATOR_SERVICE_TAGS } from "@/features/CreatorService/const";

export const resolveCreatorTagsByIds = (ids: string[]) => {
  return ids.map(i => CREATOR_SERVICE_TAGS.find(t => t.id === i)).filter(Boolean) as typeof CREATOR_SERVICE_TAGS;
};
